import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { DoxyPepResponse } from '@models/doxy-pep-response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DoxyPepService {
  private http = inject(HttpClient);

  /**
   * Get the DoxyPep content.
   *
   * @returns an Observable of the DoxyPepResponse
   */
  public getDoxyPepContent(): Observable<DoxyPepResponse> {
    return this.http
      .get(`${environment.analyteCareApi}/api/v2/public-files/doxy-pep.json`, { responseType: 'text' })
      .pipe(map((responseText) => JSON.parse(responseText)));
  }
}
